import * as React from 'react';

import { PageSeoInfo } from 'components';
import { useTagAction, useTagValue } from 'context';

const TagSeoInfo = () => {
  const { title, seo, ownerType } = useTagValue();
  const action = useTagAction();

  return (
    <PageSeoInfo
      seo={seo}
      ownerType={ownerType}
      defaultName={title}
      onUpdateSeoInfo={result => {
        action({
          type: 'UPDATE_TAG_SEO',
          payload: {
            seo: result,
          },
        });
      }}
    />
  );
};

export { TagSeoInfo };
